export const additionalServiceProjects = [
 {projectName:"haft-e-tir",title:"service.project.haft",link:"/healthcare",specs:[]},
 {projectName:"parsian-saadat-abad",title:"service.project.parsian",link:"/healthcare",specs:[]},
];
